import React from 'react';
import './Logo.css';
import HospitalLogo from '../../branding/HospitalLogo';
import useDefaultOrganizationName from '../../../hooks/useDefaultOrganizationName';

function Logo({ 
  size = 'medium', 
  variant = 'light', 
  organizationName = null, 
  locationName = null, 
  departmentName = null, 
  departmentIcon = null,
  isSuperAdmin = false 
}) {
  const sizeMap = { small: 40, medium: 60, large: 80 };
  const height = sizeMap[size] || sizeMap.medium;
  const width = height;

  const defaultOrganizationName = useDefaultOrganizationName();
  const currentOrg = organizationName || defaultOrganizationName;

  return (
    <div className={`logo-container logo-${size} variant-${variant}`}>
      
      {/* Based on the org, the right <logo>.svg file will be read */}
      <HospitalLogo
        width={width} 
        height={height} 
        variant={variant} 
        orgName={currentOrg}
      />

      <div className={`logo-text logo-text-${variant}`}>
        <div className="logo-title">
          {currentOrg}
        </div>
        {isSuperAdmin ? (
          <div className="logo-location logo-all-locations">
            🌐 All Locations
          </div>
        ) : (
          <div className="logo-context-container">
            {departmentName && (
              <div className="dept-badge-container">
                <span style={{ fontSize: '1.1rem' }}>{departmentIcon || '🏢'}</span>
                <span className="dept-name">{departmentName}</span>
              </div>
            )}
            {locationName && (
              <div className="location-badge-container">
                <span className="location-icon">📍</span>
                <span className="location-name">{locationName}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Logo;
